<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<!-- <div class="columns  is-gapless">
    <div class="column is-3">
        <div class="select  is-fullwidth has-text-weight-bold">
            <select @change="change_sess()"  class="has-text-weight-bold has-text-dark" v-model="selected_session">
                    <option value=""></option>
                    <option v-for="(choice,index) in data_sessions" :key="index" :value="choice">{{ choice }}</option>
            </select>
        </div>
    </div>
    <div class="column is-3">
        <div class="select  is-fullwidth has-text-weight-bold">
            <select  @change="change_grp()" class="has-text-weight-bold has-text-dark" v-model="selected_group">
                    <option value=""></option>
                    <option v-for="(choice,index) in data_groups" :key="index" :value="choice.group_CODE">{{ choice.group_CODE }}</option>
            </select>
        </div>
    </div>
 

    <div class="column is-1 has-text-centered">
        <button @click="toggle_program_mod()" class="button is-fullwidth has-text-weight-bold" style="background-color:LIGHTCORAL;color:white">
            <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
        </button>
    </div>
    <div class="column is-3 has-text-centered">&nbsp;</div>
    <div class="column is-2 has-text-centered">
        <button @click="insert_new_courses()" class="button is-fullwidth has-text-weight-bold" style="background-color:OLIVEDRAB;color:white">
            <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
        </button>
    </div>
</div> -->


<div @click="toggle_click(index)" v-if="data.is_saved == false" :class="return_style_selected(data.is_selected)" class="columns is-gapless isLink hoverItBack" v-for="(data,index) in data_courses" :key="index" style="margin-bottom:.4em;margin-top:.4em;border-bottom: 1px inset #BACAE3;">
<div class="column is-5" style="">
        <div class="columns is-multiline is-gapless" style="">
            <div style="margin-bottom:-0.4em;" class="column is-10 is-size-5 has-text-weight-bold">
                &nbsp;{{data.cour_CODE}}
            </div>
            <div class="column is-12 is-size-6">&nbsp;{{data.cour_TITRE_F}}</div>
        </div>
</div>


<div class="column is-6" style="">
        <div class="columns is-multiline is-gapless" style="">
            <div class="column is-5 has-text-weight-bold">{{data.sessann}}</div>
            <div class="column is-7 has-text-weight-bold has-text-danger has-text-left">{{data.group_CODE}}</div>
            <!-- <div class="column is-7">&nbsp;</div> -->
            <div style="margin-top:-0.4em;"  class="column is-12 has-text-weight-bold has-text-info is-size-6">{{data.prof1}}&nbsp;&nbsp;{{data.prof2}}</div>
        </div>
</div>




<div class="column is-1">

<button v-if="data_courses[index].is_selected == false" style="margin-top:-.5em;padding: 0;border: none;background: none;" class="button is-fullwidth has-background-white has-text-success" @click="click_add(index)"><span class="icon is-small"><i class="fas fa-user-plus"></i></span></button>
<button v-else style="margin-top:-.5em;padding: 0;border: none;background: none;" class="button is-fullwidth has-background-light has-text-dark" @click="click_undo(index)"><span class="icon is-small"><i class="fas fa-undo"></i></span></button>

</div>


</div>


</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';


export default {
        props: [ 'studentID' ],
        components: {  },

        data() {
            return {

                 isLoading:false,

data_courses:[],

data_sessions:[],
data_groups:[],
selected_session:'',
selected_group:'',


            }
        },


created() {


// GET DISTINCT GROUPS
/* var dt = moment().subtract(90, 'days').format('YYYY-MM-DD') 
var sql =  "SELECT DISTINCT group_CODE FROM myMEQ_GROUP WHERE group_datEND > '" + dt +  "' ORDER BY group_CODE"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { this.data_groups = res.data

        var i;
        for (i = 18; i < 22; i++) {
            this.data_sessions.push('H-'+ i)
            this.data_sessions.push('E-'+ i)
            this.data_sessions.push('A-'+ i)
        }

})
 */


// SET INITIAL SESSION/ANNEE
this.selected_session = moment().format('M')
if (this.selected_session < 5)  { this.selected_session = 'H'}
else if (this.selected_session < 8) { this.selected_session = 'E'}
else  { this.selected_session = 'A'}
this.selected_session += "-" +  moment().format('YY')
this.get_courses(this.selected_session,'')




},



methods : {





toggle_click:function(index) {
    if (this.data_courses[index].is_selected == true) {
        this.data_courses[index].is_selected = false;
        this.$emit('emit_course_remove',this.data_courses[index].group_ID)
    } else {
        this.data_courses[index].is_selected = true;
        this.$emit('emit_course_add',this.data_courses[index].group_ID,this.data_courses[index].group_CODE)
    }

},


click_add:function(index) {
    this.data_courses[index].is_selected = true;
    this.$emit('emit_course_add',this.data_courses[index].group_ID,this.data_courses[index].group_CODE)


},

click_undo:function(index) { 
    this.data_courses[index].is_selected = false;
    this.$emit('emit_course_remove',this.data_courses[index].group_ID)
},


change_sess:function(){
    this.selected_group = ''
    this.get_courses()
},
change_grp:function(){
    this.selected_session = ''
    this.get_courses()
},
 
get_courses:function(sess, group){
    this.isLoading = true;
    var sql = ''
    var sqlWhere = ''
    if (sess != '') {
        var res = sess.split("-");
        sqlWhere = " WHERE group_SESS = '" + res[0] + "' AND group_ANN = '" + res[1] + "'"
    } else
    { sqlWhere = " WHERE group_CODE LIKE '" + group + "%25'"}


    sql = ` SELECT cour_CODE,cour_TITRE_F,group_ID,group_CODE,group_SESS,group_ANN, MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof1, MyMEQ_STAFF_1.staff_Prenom + ' ' + MyMEQ_STAFF_1.staff_Nom AS prof2 FROM 
    MyMEQ_GROUP LEFT OUTER JOIN MyMEQ_STAFF ON MyMEQ_GROUP.staff_ID_1 = MyMEQ_STAFF.staff_ID LEFT OUTER JOIN MyMEQ_STAFF AS MyMEQ_STAFF_1 ON MyMEQ_GROUP.staff_ID_2 = MyMEQ_STAFF_1.staff_ID INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID ` + sqlWhere

console.log(sql)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
  
this.data_courses = [];
var self=this;
res.data.forEach(function(data){ 
 
    self.data_courses.push(
    { 
        cour_CODE : data.cour_CODE,
        cour_TITRE_F : data.cour_TITRE_F,
        group_ID : data.group_ID,
        group_CODE : data.group_CODE,
        sessann : data.group_SESS + "-" + data.group_ANN,
        is_selected : false,
        is_saved : false,
prof1 : data.prof1,
prof2 : data.prof2,
    
    
    });

        
     });

    this.isLoading = false;
 });

},

return_style_selected:function(isSelected) {
    if (isSelected)
    {return 'has-background-light'}
    else {return ''}

},

}, // END METHODS


}
</script>